import type { Dispatch } from 'react';
import { connect } from '@atlassian/jira-react-redux';
import type { RefObject } from '@atlassian/jira-shared-types/src/general.tsx';
import { getProjectTypeSelector } from '../../../state/context/selectors';
import type { AppState } from '../../../state/types';
import {
	type ProjectDetailsUIAction,
	openDeleteProjectModal,
	openTrashProjectModal,
	setDropDownMenuButtonRef,
} from '../../../state/ui/actions';
import Menu from './view';

const mapStateToProps = (state: AppState) => ({
	projectType: getProjectTypeSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<ProjectDetailsUIAction>) => ({
	onDelete: () => {
		dispatch(openDeleteProjectModal());
	},
	onTrash: () => {
		dispatch(openTrashProjectModal());
	},
	setDropDownMenuButtonRef: (dropDownMenuButtonRef: RefObject) => {
		dispatch(setDropDownMenuButtonRef(dropDownMenuButtonRef));
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
